export default __webpack_public_path__ + "static/media/hackiethon_finalists.a2f966c0.png";